export default __webpack_public_path__ + "static/media/clock.822b1e8f.svg";